import {createSvgIcon} from '../create-svg-icon';

export const HexagonIcon = createSvgIcon(
  <path d="M17.2 3H6.8l-5.2 9 5.2 9h10.4l5.2-9-5.2-9zm-1.15 16h-8.1l-4.04-7 4.04-7h8.09l4.04 7-4.03 7z" />
, 'HexagonOutlined');
